<template>
  <div class="mongo-instanceUser-page">
    <Drawer
      :title="addUserModalTitle"
      v-model="addUserModal"
      width="992"
      :mask-closable="true"
      @on-close="addUserCancel">
      <div>
        <i-form ref="addUserForm" :model="addUserForm" :label-width="100"
                :rules="addUserRuleValidate">
          <form-item label="账户名" prop="name">
            <i-input v-model="addUserForm.name" placeholder=""></i-input>
          </form-item>
          <form-item label="账号类型" prop="type">
            <RadioGroup v-model="addUserForm.type">
              <Radio label='1'>管理维护账号</Radio>
              <Radio label='2'>普通账号</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="密码" prop="password">
            <i-input type="password" v-model="addUserForm.password" placeholder="大写、小写、数字、特殊字符至少各一位，长度8位以上"></i-input>
          </form-item>
          <form-item label="确认密码" prop="repassword">
            <i-input type="password" v-model="addUserForm.repassword" placeholder=""></i-input>
          </form-item>
          <form-item v-if="addUserForm.type === '2'" label="数据库列表" prop="db">
            <Select v-model="addUserForm.db" clearable filterable>
              <Option v-for="item in databaseList" :value="item" :key="item" :label="item"></Option>
            </Select>
          </form-item>
          <form-item v-if="addUserForm.type === '2'" label="角色列表" prop="syspriv">
            <transfer
              :data="sysPrivList"
              :target-keys="addUserForm.syspriv"
              :list-style="listStyle"
              @on-change="addUserPrivChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="addUserSubmit">提交</i-button>
            <i-button style="margin-left: 8px" @click="addUserCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>

    <Drawer
      :title="resetPasswordModalTitle"
      v-model="resetPasswordModal"
      width="500"
      :mask-closable="true"
      @on-close="resetPasswordCancel">
      <div>
        <i-form ref="resetPasswordForm" :model="resetPasswordForm" :label-width="90"
                :rules="resetPasswordRuleValidate">
          <form-item label="新密码" prop="password">
            <i-input type="password" v-model="resetPasswordForm.password" placeholder="大写、小写、数字、特殊字符至少各一位，长度8位以上"></i-input>
          </form-item>
          <form-item label="确认密码" prop="repassword">
            <i-input type="password" v-model="resetPasswordForm.repassword" placeholder=""></i-input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="resetPassword">提交</i-button>
            <i-button style="margin-left: 8px" @click="resetPasswordCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>

    <Drawer
      :title="updatePrivModalTitle"
      v-model="updatePrivModal"
      width="992"
      :mask-closable="true"
      @on-close="updatePrivCancel">
      <div>
        <i-form ref="updatePrivForm" :model="updatePrivForm" :label-width="100">
          <form-item label="权限" prop="privileges">
            <transfer
              :data="sysPrivList"
              :target-keys="updatePrivForm.roles"
              :list-style="listStyle"
              @on-change="privChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="updatePrivilege">提交</i-button>
            <i-button style="margin-left: 8px" @click="updatePrivCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>
    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row>
        <i-col span="24" :md="20">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="用户名" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getInstanceUser()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstanceUser()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="4" class="align-right">
        <Button style="float: right;" @click="addUser()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加用户
        </Button>
        </i-col>
      </Row>
      <tables ref="instanceUserTable" height="600" search-place="top" v-model="instanceUserData"
              :columns="userColumns" class="mob-remove-table-fixed"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceUser"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getInstanceUserList, resetUserPassword, getRoleNameList, deleteInstanceUser, getPrivList, updatePrivilege, showDatabaseList, createUser} from '@/api/mongodb'

export default {
  name: 'MongoDBInstanceUser',
  components: {
    Tables
  },
  data: function () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    const validateUserPassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.addUserForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    return {
      searchForm: {
        name: ''
      },
      roleStyle: {
        display: 'none'
      },
      listStyle: {
        width: '400px',
        height: '350px'
      },
      // 回收权限
      updatePrivModal: false,
      updatePrivModalTitle: '权限变更',
      updatePrivForm: {
        name: '',
        db: '',
        roles: []
      },

      // 重置密码
      resetPasswordModal: false,
      resetUser: null,
      resetDB: null,
      headRoles: [],
      resetPasswordModalTitle: '重置密码',
      resetPasswordForm: {
        password: '',
        repassword: ''
      },
      resetPasswordRuleValidate: {
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validatePassCheck, trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      userColumns: [
        {title: 'user', key: 'user', align: 'center', width: 150},
        {title: 'db', key: 'db', width: 150},
        {title: 'credentials', key: 'credentials', width: 400, tooltip: true},
        {title: 'roles', key: 'roles', width: 400, tooltip: true},
        {
          title: '操作',
          width: 220,
          fixed: 'right',
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                    // shape: 'circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetUser = params.row.user
                      this.resetDB = params.row.db
                      this.resetPasswordModal = true
                    }
                  }
                }, [
                  h('div', '重置密码')
                ]),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let data = {
                        id: this.$route.query.id,
                        name: params.row.user,
                        db: params.row.db
                      }
                      this.getPrivs(data)
                      this.getRoleNames()
                      this.resetUser = params.row.user
                      this.resetDB = params.row.db
                      this.updatePrivModal = true
                    }
                  }
                }, [
                  h('div', '权限变更')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params.row.db, params.row.user)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ],
      instanceUserData: [],

      // 添加用户
      addUserModalTitle: '创建账号',
      addUserModal: false,
      databaseList: [],
      addUserForm: {
        id: this.$route.query.id,
        name: '',
        network_segment: '',
        password: '',
        type: '2',
        db: '',
        syspriv: []
      },
      addUserRuleValidate: {
        name: [{required: true, message: '请输入数据库账户', trigger: 'blur'}],
        db: [{required: true, message: '请选择数据库', trigger: 'blur'}],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validateUserPassCheck, trigger: 'blur'}]
      },
      sysPrivList: [],

      // 添加授权
      addPrivsModalTitle: '添加授权',
      addPrivsModal: false,
      addPrivsForm: {
        id: this.$route.query.id,
        name: '',
        syspriv: []
      }
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getInstanceUser()
    },
    refresh () {
      this.getInstanceUser()
    },
    getInstanceUser (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        ordering: this.ordering,
        name: this.searchForm.name
      }
      getInstanceUserList(params).then(res => {
        this.instanceUserData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },

    resetPasswordCancel () {
      this.resetPasswordForm.password = ''
      this.resetPasswordForm.repassword = ''
      this.resetPasswordModal = false
    },

    resetPassword () {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.$route.query.id,
            name: this.resetUser,
            db: this.resetDB,
            password: this.resetPasswordForm.password
          }
          resetUserPassword(data).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getInstanceUser()
            this.resetPasswordCancel()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    handleDelete (db, user) {
      let data = {
        id: this.$route.query.id,
        db: db,
        name: user
      }
      deleteInstanceUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceUser()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    getPrivs (data) {
      // let that = this
      // that.privList = []
      getPrivList(data).then(res => {
        if (res.status === 200) {
          this.updatePrivForm.roles = res.data.results
          this.headRoles = res.data.results
          // let result = res.data.results
          // for (let i in result) {
          //   that.privList.push({
          //     key: result[i],
          //     label: result[i]
          //   })
          // }
        }
      })
    },
    privChange (newTargetKeys) {
      this.updatePrivForm.roles = newTargetKeys
    },
    updatePrivCancel () {
      this.updatePrivForm.roles = []
      this.updatePrivModal = false
    },
    updatePrivilege () {
      this.$refs['updatePrivForm'].validate((valid) => {
        if (valid) {
          if (this.updatePrivForm.roles !== this.headRoles) {
            let data = {
              id: this.$route.query.id,
              name: this.resetUser,
              db: this.resetDB,
              roles: this.updatePrivForm.roles,
              head_roles: this.headRoles
            }
            updatePrivilege(data).then(res => {
              this.$Notice.success({title: '操作成功！'})
              this.getInstanceUser()
              this.updatePrivCancel()
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        }
      })
    },
    addUser () {
      this.getDatabases()
      this.getRoleNames()
      this.addUserModal = true
    },

    addUserPrivChange (newTargetKeys) {
      this.addUserForm.syspriv = newTargetKeys
    },

    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          this.databaseList = res.data.results
        }
      })
    },

    getRoleNames () {
      let that = this
      that.sysPrivList = []
      getRoleNameList().then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.sysPrivList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    getRole () {
      let that = this
      that.addPrivsForm.syspriv = []
      getRoleNameList().then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.sysPrivList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    addUserCancel () {
      this.addUserForm.name = ''
      this.addUserForm.network_segment = ''
      this.addUserForm.password = ''
      this.addUserForm.repassword = ''
      this.addUserForm.type = '2'
      this.addUserForm.db = ''
      this.addUserForm.syspriv = []
      this.addUserModal = false
    },
    addUserSubmit () {
      this.$refs['addUserForm'].validate((valid) => {
        if (valid) {
          createUser(this.addUserForm).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getInstanceUser()
            this.addUserCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    }
  },

  mounted: function () {
    this.getInstanceUser()
  }
}
</script>
<style lang="less">
  @media screen and (max-width:640px) {
    .mongo-instanceUser-page {
      h1 {
        font-size: 1.5em;
      }
      .ivu-divider-horizontal{
        margin:10px 0 15px;
      }
    }
  }
</style>
